export default "__VITE_ASSET__DMGk4ZEt__"